import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { outcomes } from '../data/outcomes';
export function OutcomesSection() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-210" data-mp="16foawtqxdk8t">
      <div className="mx-auto max-w-3xl" data-id="element-211" data-mp="12e2p2iwexvmh">
        <SectionHeading title={<>
              What you'll be able to <span className="text-electric-600" data-id="element-213" data-mp="1z2iiiq2n8p4v">organize</span> with the system
            </>} subtitle="TCM Diagnostic Blueprint™ is designed for technicians who want a more structured approach to their work. It can help you:" data-id="element-212" data-mp="12f5jh0sy2g75" />
        <ul className="mx-auto mt-10 grid max-w-2xl gap-3 sm:grid-cols-2" data-id="element-214" data-mp="1lcoqxzzr7qrg">
          {outcomes.map(o => <li key={o} className="flex gap-3 rounded-2xl bg-white p-4 text-[15px] font-medium leading-snug text-ink" data-id="element-215" data-mp="2huuu83f6t2ro">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-cta-600" aria-hidden="true" data-id="element-216" data-mp="2d2jr6rp5h0uw" />
              {o}
            </li>)}
        </ul>
        <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-muted" data-id="element-217" data-mp="tug8qm8b7mql">
          The system doesn't guarantee a diagnosis or a repair. Its purpose is to help you organize your work and make
          more informed decisions using the information available to you.
        </p>
        <CtaButton label="I want a repeatable workshop process" className="mt-10" data-id="element-218" data-mp="64vdp4yvsz0y" />
      </div>
    </section>;
}